<template>
    <canvas ref="chart" style="height: 300px;" />
</template>

<script>
import Chartisan from '../../../libraries/chart/chartisan';
import ChartisanHooks from '../../../libraries/chart/chartisan-hooks';

export default {
  name: 'NotificationSummary',

  mounted() {
    // eslint-disable-next-line no-new
    new Chartisan({
      el: this.$refs.chart,
      url: this.url,
      hooks: new ChartisanHooks()
        .tooltip(true)
        .legend({
          position: 'bottom',
          usePointStyle: true,
        })
        .datasets([{ type: 'line' }]),
    });
  },

  computed: {
    url() {
      return `/api/chart/notification_summary`;
    },
  },
};
</script>
